import Select from 'shared/components/Select'
import MenuList from 'shared/components/Select/NearMe'
import debounce from 'debounce'

import { loadGoogleAPI } from '../../map/actions'
import { withRouter } from 'i18n/utils'

import { combinedLocationsListSelector, searchSelector, locationSearchPendingSelector } from '../selectors'
import { fetchLocationsByName, setLocation, removeLocation } from '../actions'
import useBeforeFirstRender from 'shared/hooks/use-before-first-render'

const LocationSelect = ({
    fetchLocationsByName,
    search,
    isClearable,
    scaleEffect,
    locations,
    icon,
    size,
    onFocusChange,
    loadGoogleAPI,
    setLocation,
    history,
    removeLocation,
    locationSearchPending,
    placeholder,
}) => {
    const [locationValue, setLocationValue] = React.useState(search.location || null)

    useBeforeFirstRender(() => {
        loadGoogleAPI()
        removeLocation()
    })

    const onSelectInputChange = value => {
        fetchLocationsByName(value)
    }

    const onSelectInputChangeDenounced = debounce(onSelectInputChange, 500)

    const onLocationChange = location => {
        if (location) {
            setLocation(location)
            history.push('/map')
        }

        setLocationValue(location)
    }

    return (
        <Select
            noOptionsCustomMessage={<T>search.no-results</T>}
            enterTermMessage={<T>select.enter-term</T>}
            borders={false}
            arrow={false}
            isClearable={isClearable}
            scaleEffect={scaleEffect}
            isLoading={locationSearchPending}
            size={size}
            icon={icon}
            placeholder={placeholder}
            options={locations}
            components={{ MenuList }}
            onInputChange={onSelectInputChangeDenounced}
            onChange={onLocationChange}
            onFocus={onFocusChange}
            onBlur={onFocusChange}
            value={locationValue}
            filterOption={false}
        />
    )
}

LocationSelect.propTypes = {
    size: PropTypes.oneOf(['small', 'large']).isRequired,
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
    isClearable: PropTypes.bool,
    scaleEffect: PropTypes.bool,
    onFocusChange: PropTypes.func,
}

const mapStateToProps = createStructuredSelector({
    locations: (state, props) => combinedLocationsListSelector(state, props.bookableMode),
    search: searchSelector,
    locationSearchPending: locationSearchPendingSelector,
})

const mapDispatchToProps = {
    fetchLocationsByName,
    loadGoogleAPI,
    setLocation,
    removeLocation,
}

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(LocationSelect)
